import { RESULT_PATTERN } from "@/const/config";
import str2utf16 from "@/js/libs/str2utf16";

export default function decideResultFromStr(str) {
  // 文字コード数値を加算したものをパターン数で割った余りが結果のID
  return str2utf16(str) % RESULT_PATTERN.length;
}
